import { select } from '@soltalabs/stateless'
import { SiteModule } from './module'
import { prop, path } from '@soltalabs/ramda-extra'

const { state$, effectState$ } = SiteModule

const entities$ = select(state$, prop('entities'))
const order$ = select(state$, prop('order'))

const siteList$ = select(entities$, order$, (entities, order) => {
  return order.map((id) => prop(id)(entities))
})

const isFetchingSites$ = select(effectState$, (state) => {
  const status = path(['fetchSites', 'status'])(state)

  return status === 'pending'
})

export { siteList$, isFetchingSites$ }
